import { gql } from '@apollo/client';

export const GET_BRIEFS_QUERY = gql`
  query GetBriefsQuery($filters: BriefDashboardFilterInput!) {
    briefs: getBriefDashboardTableData(filters: $filters) {
      data {
        id
        briefId
        briefIterationId
        member {
          id
          name
          profilePicture
        }
        project {
          id
          name
        }
        status
        paymentStatus
        deliverables
        payment
        amountPaid
        createdDate
        updatedDate
        agreedDate
        lastActivity
        lastReviewer
        usageRights
        budgets {
          amount
          budgetId
          budgetName
          budgetPeriodDefinitionId
          fiscalGranularityLabel
          fiscalYear
          programId
        }
        budgetPeriodDefinitionId
        fiscalGranularityLabel
        fiscalYear
        fiscalYearLabel
      }
      page
      pageSize
      total
      totalPages
    }
  }
`;
